import { cn } from "@/lib/utils";

export type HeadingProps = {
  level: "h1" | "h2" | "h3" | "h4";
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLHeadingElement>;

export function Heading({
  level,
  children,
  className,
  ...props
}: HeadingProps) {
  const Tag = level;
  return (
    <Tag
      {...props}
      className={cn(
        "font-semibold",
        {
          "text-3xl lg:text-4xl": level === "h1", // 3rem / 48px
          "text-2xl lg:text-3xl": level === "h2", // 2.25rem / 36px
          "text-xl lg:text-2xl": level === "h3", // 1.875rem / 30px
          "text-lg lg:text-xl": level === "h4", // 1.5rem / 24px
        },
        className,
      )}
    >
      {children}
    </Tag>
  );
}

Heading.displayName = "Heading";

export function H1(props: Omit<HeadingProps, "level">) {
  return <Heading level="h1" {...props} />;
}

H1.displayName = "H1";

export function H2(props: Omit<HeadingProps, "level">) {
  return <Heading level="h2" {...props} />;
}

H2.displayName = "H2";

export function H3(props: Omit<HeadingProps, "level">) {
  return <Heading level="h3" {...props} />;
}

H3.displayName = "H3";

export function H4(props: Omit<HeadingProps, "level">) {
  return <Heading level="h4" {...props} />;
}

H4.displayName = "H4";
